<button 
    [type]="type"
    [disabled]="disabled" 
    [attr.size]="size"
    [attr.theme]="theme"
    [attr.shadow]="shadow"
    [attr.shape]="shape"
>
    <i *ngIf="icon" [class]="'ic-icon-' + icon"></i>
    <span><ng-content></ng-content></span>
</button>